export const IMAGES = {
  edit: '/images/edit.png',
  logo: '/images/aitag-logo.png',
  defaultThumbnail: '/images/default-thumbnail.png',
  imageAdd: '/images/image-add.png',
  aiSettings: '/images/sliders.png',
  camera: '/images/camera.svg',
  loader: '/images/loader.svg',
  check: '/images/check.svg',
  prev: '/images/prev.svg',
  setting: '/images/setting.svg',
} as const;
